import { getData, putData } from '@/utils/api';
import { ApiResponse, RequestOptions } from '@/types/api';
import { SupportersApiModel, SupporterApiModel } from '@/types/supporters';
import { FootballlogApiModel, FootballlogFeedListApiModel } from '@/types/footballlogs';

/**
 * サポーター情報を取得
 */
export async function getSupporter(
  footballerId: number,
  options?: RequestOptions
): Promise<ApiResponse<SupporterApiModel>> {
  const apiPath = `supporters/${footballerId}/`;

  return await getData<SupporterApiModel>(apiPath, options);
}

/**
 * 自分がしたサポートリクエストの一覧を取得
 */
export async function getSupportRequests(
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<SupportersApiModel>> {
  const params = new URLSearchParams();

  // デフォルトソート(固定): リクエスト順にソート
  params.append('sort', 'updatedat');
  params.append('order', 'desc');

  params.set('limit', String(limit));
  params.set('offset', String(offset));

  const queryParams = `?${params.toString()}`;
  const apiPath = `supporters/support-requests/${queryParams}`;

  return await getData<SupportersApiModel>(apiPath, options);
}

/**
 * 自分がされたサポートリクエストの一覧を取得
 */
export async function getSupportRequested(
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<SupportersApiModel>> {
  const params = new URLSearchParams();

  // デフォルトソート(固定): リクエスト順にソート
  params.append('sort', 'updatedat');
  params.append('order', 'desc');

  params.set('limit', String(limit));
  params.set('offset', String(offset));

  const queryParams = `?${params.toString()}`;
  const apiPath = `supporters/support-requested/${queryParams}`;

  return await getData<SupportersApiModel>(apiPath, options);
}

/**
 * 自分のサポーター情報を取得
 */
export async function getSupporters(
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<SupportersApiModel>> {
  const apiPath = `supporters/?limit=${limit}&offset=${offset}`;

  return await getData<SupportersApiModel>(apiPath, options);
}

/**
 * 自分の全てのサポーターのサッカーノート(フィード)一覧を取得
 */
export async function getSupportersFootballlogs(
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogFeedListApiModel>> {
  const apiPath = `supporters/footballlogs/?limit=${limit}&offset=${offset}`;

  return await getData<FootballlogFeedListApiModel>(apiPath, options);
}

/**
 *  自分のサポーター(一人)のサッカーノート(フィード)一覧を取得
 */
export async function getOneOfSupportersFootballlogs(
  footballerId: number,
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogFeedListApiModel>> {
  const apiPath = `supporters/${footballerId}/footballlogs/?limit=${limit}&offset=${offset}`;

  return await getData<FootballlogFeedListApiModel>(apiPath, options);
}

/**
 * サポーターの最新のノートを取得を取得
 */
export async function getSupportersFootballlog(
  footballerId: number,
  footballlogId: number,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogApiModel>> {
  // NOTE: バックエンドで指定footballerIdがログインセッションuserとサポート関係にあるか
  // チェックしている。サポート関係にないidを指定するとエラーとなる
  const apiPath = `supporters/${footballerId}/footballlogs/${footballlogId}/`;

  return await getData<FootballlogApiModel>(apiPath, options);
}

/**
 * サポーターの最新のノートを取得を取得
 */
export async function getSupportersCurrentFootballlog(
  footballerId: number,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogApiModel>> {
  // NOTE: バックエンドで指定footballerIdがログインセッションuserとサポート関係にあるか
  // チェックしている。サポート関係にないidを指定するとエラーとなる
  const apiPath = `supporters/${footballerId}/footballlogs/current/`;

  return await getData<FootballlogApiModel>(apiPath, options);
}

/**
 * サポートリクエスト
 */
export async function requestSupporting(
  footballerId: number,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `supporters/${footballerId}/request-supporting/`;

  return await putData<void>(apiPath, csrftoken, options);
}

/**
 * サポートリクエスト承認
 */
export async function approveSupporting(
  footballerId: number,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `supporters/${footballerId}/approve-supporting/`;

  return await putData<void>(apiPath, csrftoken, options);
}

/**
 * サポートリクエスト取り消し
 */
export async function cancelSupporting(
  footballerId: number,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `supporters/${footballerId}/cancel-supporting/`;

  return await putData<void>(apiPath, csrftoken, options);
}
